module.exports = __webpack_public_path__ + "img/login.51fa608f.jpg";